import { useScroll, useTransform } from 'framer-motion'
import { useMedia } from 'hooks/useMedia'
import { useRef } from 'react'
import { breakpoints } from 'styles/mq'

type Props = {
  fromTo: [string, string]
}

export const useParallax = ({ fromTo }: Props) => {
  const ref = useRef<HTMLDivElement>(null)
  const isMobile = useMedia([breakpoints.parallaxOff], [true], false)
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ['end end', 'start start'],
  })

  const translateY = useTransform(scrollYProgress, [0, 1], fromTo)

  return {
    translateY: isMobile ? 0 : translateY,
    isMobile,
    ref,
  }
}
